import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		cart: [],
		cartSubscription: [],
		product: []
	},
	mutations: {
		addProductCart(state, productData){
			state.cart.push(productData);
			localStorage.setItem('shoppingCart', JSON.stringify(state.cart));
		},
		updateCart(state, cartData){
			console.log('actualizando carrito');
			localStorage.setItem('shoppingCart', JSON.stringify(cartData));
		},
		initialiseStore(state){
			if (localStorage.getItem('shoppingCart')) {
				state.cart = JSON.parse(localStorage.getItem('shoppingCart'));
			}
		},
		finishStore(state){
			localStorage.setItem('shoppingCart', []);
			state.cart = [];
		},
		addProductCartSubscription(state, productData){
			state.cartSubscription.push(productData)
			localStorage.setItem('shoppingCartSubscription', JSON.stringify(state.cartSubscription));
		},
		updateCartSubscription(state, cartSubscriptionData){
			console.log('actualizando carrito suscripcion');
			localStorage.setItem('shoppingCartSubscription', JSON.stringify(cartSubscriptionData));
		},
		initialiseStoreSubscription(state){
			if(localStorage.getItem('shoppingCartSubscription')){
				state.cartSubscription = JSON.parse(localStorage.getItem('shoppingCartSubscription'));
			}
		},
		finishStoreSubscription(state){
			localStorage.setItem('shoppingCartSubscription', []);
			state.cartSubscription = [];
		},
		saveProduct(state, productData){
			state.product.push(productData)
			localStorage.setItem('productWaiting', JSON.stringify(state.product));
		},
		saveSeveralProducts(state, products){
			state.product = products;
			localStorage.setItem('productWaiting', JSON.stringify(state.product));
		},
		initialiseProduct(state){
			if(localStorage.getItem('productWaiting')){
				state.product = JSON.parse(localStorage.getItem('productWaiting'));
			}
		},
		finishProduct(state){
			localStorage.setItem('productWaiting', []);
			state.product = [];
		},
	},
});
